import { useMemo } from 'react';
import { breakpoints } from 'shared/style/media';
import useWindowSize from './useWindowSize';

const useIsMobile = (screenSize = breakpoints.tablet) => {
  const { width } = useWindowSize();
  const isCurrentSize = useMemo(() => screenSize >= width, [width]);

  return isCurrentSize;
};

export default useIsMobile;
